import React, { useContext, useEffect, useState } from "react";
import { createIPRestrictionAPI, getIPRestrictionsAPI, removeIPRestrictionAPI, updateIPRestrictionAPI } from "../../../api/identity";
import IPRangeRestrictionTable from "../../../components/Settings/IpRestrictionTable";
import IPRangeRestrictionForm from "../../../components/Settings/IpRestrictionForm";
import AdminContext from "../AdminContext/AdminContext";

export default function IPRangeRestrictionContainer() {
    const [items, setItems] = useState([]);
    const [editing, setEditing] = useState(null);
    const [showForm, setShowForm] = useState(false);

    const context = useContext(AdminContext);
    
    const loadItems = async () => {
        const response = await getIPRestrictionsAPI();
        setItems(response.data);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const handleEdit = (item) => {
        setEditing(item);
        setShowForm(true);
    };

    const handleDelete = async (id) => {
        await removeIPRestrictionAPI(id);
        loadItems();
    };

    const handleFormSubmit = async (values) => {
        if (!values) return;
        values.tenantId = context?.selectedTenant?.tenantId;

        if (values.id) await updateIPRestrictionAPI(values.id, values);
        else await createIPRestrictionAPI(values);
        setShowForm(false);
        setEditing(null);
        loadItems();
    };

    return (
        <div className="container mt-4">
            <h2>IP Range Restrictions</h2>
            <button className="btn btn-primary mb-3" onClick={() => { setEditing(null); setShowForm(true); }}>Agregar</button>
            <IPRangeRestrictionTable items={items} onEdit={handleEdit} onDelete={handleDelete} />
            {showForm && (
                <IPRangeRestrictionForm
                    initialValues={editing || {}}
                    onSubmit={handleFormSubmit}
                    onCancel={() => setShowForm(false)}
                />
            )}
        </div>
    );
}